 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"npm.echarts-wordcloud":"npm.echarts-wordcloud","npm.katex":"npm.katex","npm.markdown-it":"npm.markdown-it","npm.uslug":"npm.uslug","npm.unorm":"npm.unorm","npm.antv":"npm.antv","npm.regl":"npm.regl","npm.gl-matrix":"npm.gl-matrix","npm.pdfjs-dist":"npm.pdfjs-dist"}[chunkId]||chunkId) + "." + {"chunk-033341ae":"26924db8","chunk-103b5298":"d5d23507","chunk-1460ba2e":"21145573","chunk-1fe3e3c6":"4cf9ecf6","chunk-2d0e17b4":"f7702813","chunk-332b0af8":"f2a5f400","chunk-3c927a5a":"e6d50d9f","chunk-4423c846":"d123f072","chunk-469bfc6f":"8e980e0e","chunk-4722fe1a":"2b87f39f","chunk-48d88fb4":"a1af1a32","chunk-4973eb44":"0525c4ed","chunk-53a072b5":"54fbb932","chunk-592ab35d":"1480c313","chunk-5da1749d":"f0dfe181","chunk-64aacb4b":"16a71e44","chunk-66251979":"da6a8fc2","chunk-6a1d959c":"20bf7a82","chunk-73c0a10f":"424b221d","chunk-7d1ff546":"26909b2a","chunk-95a1b290":"fd1076fc","chunk-b0e94602":"02779394","chunk-cef6d80e":"d531f7dc","chunk-d49f9338":"030c7298","chunk-e3c077a0":"fc3360b2","npm.echarts-wordcloud":"1f680943","chunk-5e573d69":"25a8e02c","chunk-1236a4d3":"c75bbd74","chunk-7336880f":"e1cc6582","npm.katex":"0e35976d","npm.markdown-it":"52dd7ed8","npm.uslug":"78c3abbb","npm.unorm":"40bc4064","chunk-bfe9e07c":"fb6b7543","chunk-eb37b50e":"baf206cd","npm.antv":"a286382f","npm.regl":"d59acee3","npm.gl-matrix":"3acd04dd","chunk-4c72ebc3":"061f43a0","chunk-8dcde0a2":"b5ad86b6","npm.pdfjs-dist":"841e3798","chunk-dbbe3034":"e0ccc0a6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-033341ae":1,"chunk-103b5298":1,"chunk-1460ba2e":1,"chunk-1fe3e3c6":1,"chunk-332b0af8":1,"chunk-3c927a5a":1,"chunk-4423c846":1,"chunk-469bfc6f":1,"chunk-4722fe1a":1,"chunk-48d88fb4":1,"chunk-4973eb44":1,"chunk-53a072b5":1,"chunk-592ab35d":1,"chunk-5da1749d":1,"chunk-64aacb4b":1,"chunk-66251979":1,"chunk-6a1d959c":1,"chunk-73c0a10f":1,"chunk-7d1ff546":1,"chunk-95a1b290":1,"chunk-b0e94602":1,"chunk-cef6d80e":1,"chunk-d49f9338":1,"chunk-e3c077a0":1,"chunk-5e573d69":1,"chunk-1236a4d3":1,"chunk-7336880f":1,"chunk-bfe9e07c":1,"chunk-eb37b50e":1,"chunk-4c72ebc3":1,"chunk-8dcde0a2":1,"chunk-dbbe3034":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"npm.echarts-wordcloud":"npm.echarts-wordcloud","npm.katex":"npm.katex","npm.markdown-it":"npm.markdown-it","npm.uslug":"npm.uslug","npm.unorm":"npm.unorm","npm.antv":"npm.antv","npm.regl":"npm.regl","npm.gl-matrix":"npm.gl-matrix","npm.pdfjs-dist":"npm.pdfjs-dist"}[chunkId]||chunkId) + "." + {"chunk-033341ae":"d24d467d","chunk-103b5298":"70588a28","chunk-1460ba2e":"a2a17e64","chunk-1fe3e3c6":"02e22881","chunk-2d0e17b4":"31d6cfe0","chunk-332b0af8":"7dc212c5","chunk-3c927a5a":"5d6170e2","chunk-4423c846":"c76f8ee1","chunk-469bfc6f":"f1dd49b1","chunk-4722fe1a":"2cce3742","chunk-48d88fb4":"8f1dab9f","chunk-4973eb44":"05ab458f","chunk-53a072b5":"b07cc2b3","chunk-592ab35d":"a772de46","chunk-5da1749d":"5d7caf1b","chunk-64aacb4b":"a7966144","chunk-66251979":"c76bd8c9","chunk-6a1d959c":"5bfdae4e","chunk-73c0a10f":"2a95c573","chunk-7d1ff546":"20b3428f","chunk-95a1b290":"1327add2","chunk-b0e94602":"dc68a620","chunk-cef6d80e":"30c331e5","chunk-d49f9338":"96a6705c","chunk-e3c077a0":"2919f5a8","npm.echarts-wordcloud":"31d6cfe0","chunk-5e573d69":"04270832","chunk-1236a4d3":"4782e4c0","chunk-7336880f":"a33035cb","npm.katex":"31d6cfe0","npm.markdown-it":"31d6cfe0","npm.uslug":"31d6cfe0","npm.unorm":"31d6cfe0","chunk-bfe9e07c":"3c3b0528","chunk-eb37b50e":"13b64544","npm.antv":"31d6cfe0","npm.regl":"31d6cfe0","npm.gl-matrix":"31d6cfe0","chunk-4c72ebc3":"1b3869e0","chunk-8dcde0a2":"36de939e","npm.pdfjs-dist":"31d6cfe0","chunk-dbbe3034":"b32d5245"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/knowservePlatform/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"npm.echarts","npm.core-js","npm.lodash","npm.zrender","npm.d3-selection","npm.d3-transition","npm.axios","npm.element-ui","npm.animate.css","npm.buffer","npm.html2canvas","npm.vue-print-nb","npm.vue-router","npm.vue","npm.vuex","chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
